module.exports = __webpack_public_path__ + "media/feedback-1-e1ba2b1ee49766657a1bca7c222925a9.gif";